export default "__VITE_ASSET__Bbu$IMiw__"